
export enum Gender {
  NotDefined = 0,
  Male = 1,
  Female = 2,
  MaleAndFemale = 3
}
